export default {
    approvals: {
        title: "Approbation",
        error: "Une erreur s'est produite"
    },
    delegates: {
        title: "Délégués",
        error: "Une erreur s'est produite",
        noDelegates: "Aucun article",
        delegateDelete: "Le délégué a été supprimé",
        confirm: {
            delete: "Supprimer le délégué ?"
        },
        delegates: {
            email: "E-mail",
            startDate: "Date de début",
            endDate: "Date de fin",
        },
        buttons: {
            add: {
                text: "Ajouter un délégué"
            }
        }
    },
    employees: {
        title: "Mes employés",
        error: "Une erreur s'est produite",
        empty: "Aucun employé trouvé",
        users: {
            name: "Nom",
            email: "E-mail"
        },
        model: {
            search: {
                placeholder: "Recherche",
            }
        },
        cta: {
            orders: "Ordres de chargement",
            download: "Télécharger les commandes",
            search: "Recherche"
        }
    }
}